<template>
    <a-textarea
      :value="props.modelValue"
      :placeholder="placeholder"
      :onInput="dataChange"
      :disabled="props.disabled"
    />
  </template>
  
  <script setup>
    import { reactive, ref, toRaw, defineProps, defineEmits, watch } from 'vue'
    const emit = defineEmits()
  
    const props = defineProps({
      modelValue: {
        required: true, //是否必传
      },
      label: {
        type: String, // 参数类型
        required: true, //是否必传
      },
      value: {
        required: true, //是否必传
      },
      placeholder: {
        type: String, // 参数类型
      },
      'allow-clear': {
        default: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    })
    const placeholder = props.placeholder
      ? props?.placeholder
      : `请输入${props?.label}`
  
    function dataChange(data) {
      emit('update:modelValue', data?.target?.value)
    }
  </script>
  
  <style lang="less" scoped></style>
  